import React, { useMemo } from "react";
import "./barcode.css";
import Barcode from 'react-barcode';

export default function BarcodePrint(props) {
  const { searchResult = [], componentRef } = props;

  const sortedList = useMemo(() => {
    if (!searchResult || searchResult.length <= 1) return searchResult || [];
    const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

    return [...searchResult].sort((a, b) => {
      const callA = a.bookClassificationNo || a.callNo || '';
      const callB = b.bookClassificationNo || b.callNo || '';

      if (!callA && callB) return 1;
      if (callA && !callB) return -1;

      const cmp = naturalCollator.compare(String(callA), String(callB));
      if (cmp !== 0) return cmp;

      // Secondary sort: Accession No ascending
      const numA = parseInt(a.accessionNo, 10);
      const numB = parseInt(b.accessionNo, 10);
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
      return naturalCollator.compare(String(a.accessionNo || ''), String(b.accessionNo || ''));
    });
  }, [searchResult]);

  return (
    <div ref={componentRef} className="barcode-print-root">
      {sortedList && sortedList.length > 0 ? (
        sortedList.map((item, index) => {
          const accessionVal = String(item.accessionNo || '').trim();
          const callNo = item.bookClassificationNo
            ? String(item.bookClassificationNo).trim()
            : item.callNo
            ? String(item.callNo).trim()
            : '';

          return (
            <div className="barcode-container" key={item.accessionNo || index}>
              <div className="barcode-display">
                <div className="barcode-label">
                  {callNo ? (
                    <div className="barcode-call-number">
                      {callNo}
                    </div>
                  ) : null}
                  <div className="barcode-svg-wrapper">
                    <Barcode
                      value={accessionVal || '000000'}
                      width={2.5}
                      height={25}
                      fontSize={17}
                      margin={0}
                      displayValue={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : null}
    </div>
  );
}
